import {
  durationParts,
  summarizeWeekdays,
  weekdaySummaryLabel,
} from '@/domain/reservations/reservation-guide';

export type TGuideTranslate = (
  key: string,
  params?: Record<string, unknown>
) => string;

/** «2 h», «1 h 30», «45 min»: the one way the guide writes a duration. */
export function guideDurationLabel(
  minutes: number,
  tr: TGuideTranslate
): string {
  const parts = durationParts(minutes);
  if (parts.hours === 0)
    return tr('reservations.guide.durationMinutes', { minutes: parts.minutes });
  if (parts.minutes === 0)
    return tr('reservations.guide.durationHours', { hours: parts.hours });
  return tr('reservations.guide.durationHoursMinutes', {
    hours: parts.hours,
    minutes: parts.minutes,
  });
}

/** «Todos los días» / «Lun a Sáb» / «Sáb y Dom» / «Dom» (steps and the finish summary). */
export function guideWeekdaysLabel(
  days: readonly number[],
  locale: string,
  tr: TGuideTranslate
): string {
  return weekdaySummaryLabel(summarizeWeekdays(days), locale, {
    all: tr('reservations.guide.hours.daysAll'),
    fromTo: (from, to) => tr('reservations.guide.fromTo', { from, to }),
    list: (list, last) =>
      tr('reservations.guide.hours.daysList', { list, last }),
  });
}
